<template>
    <div class="requests-link">
        <div v-if="isMenu" class="side-menu" v-click-outside="closeMenu">
            <icon @click.prevent="toggleMenu" type="solid" name="faScrewdriverWrench" aria-hidden="true" focusable="false" class="nav-icon" :title="linkTooltip"></icon>
            <span @click.prevent="toggleMenu" v-if="badgeCount > 0" class="td-circle-badge">{{ badgeCount }}</span>
            <transition name="layoutdropdown">
                <div class="menu-list" v-if="showMenu">
                    <a class="item" href="/servicerequests/vendor" title="Service Requests" aria-label="Received Service Requests">
                        Received Service Requests<span class="title">Service requests you have received received from customers</span>
                    </a>
                    <a class="item" href="/servicerequests/fleet" title="Service Requests" aria-label="Sent Service Requests">
                        Sent Service Requests<span class="title">Service requests you have sent to vendors</span>
                    </a>
                </div>
            </transition>
        </div>

        <a v-if="!isMenu" :href="linkUrl" class="service-requests" :title="linkTooltip">
            <icon type="solid" name="faScrewdriverWrench" aria-hidden="true" focusable="false" class="nav-icon" :title="linkTooltip"></icon>
            <span v-if="badgeCount > 0" class="td-circle-badge">{{ badgeCount }}</span>
        </a>
    </div>

</template>

<script>
import script from './RequestsLink';
    export default script;</script>

<style lang="less">
    @import "./RequestsLink.less";
</style>